import { getDefaultCurrencySymbol, CurrencyCode, } from '@doordash/lib-i18n';
import { TEAM_ACCOUNT_COUNTRY_CODE } from '../types/portal_data';
import i18n from '../i18n';
var DEFAULT_CURRENCY_AMOUNT_FOR_SYMBOL = 100;
export var getCurrencyByTeamAccountCountry = function (teamAccountCountryCode) {
    switch (teamAccountCountryCode) {
        case TEAM_ACCOUNT_COUNTRY_CODE.US:
        case TEAM_ACCOUNT_COUNTRY_CODE.UNSPECIFIED:
            return CurrencyCode.USD;
        case TEAM_ACCOUNT_COUNTRY_CODE.AU:
            return CurrencyCode.AUD;
        case TEAM_ACCOUNT_COUNTRY_CODE.CA:
            return CurrencyCode.CAD;
        default:
            return CurrencyCode.USD;
    }
    return CurrencyCode.USD;
};
/**
 * Given that an admin could be managing the budget of an oversea office
 * display the currency symbol for a particular team account, taking into consideration of the user locale
 */
export var getCurrencySymbolForTeamAccountCountry = function (teamAccountCountryCode, locale) {
    if (locale === void 0) { locale = i18n.getCurrentLocale(); }
    try {
        // https://github.com/doordash/web-next/blob/f6e8ceaa7394b24fcf115876ed4b76ced0604375/packages/lib-i18n/src/web/localizers/currency/index.ts#L115-L141
        // heavily borrow from the internal method in @doordash/lib-i18n
        var currency = getCurrencyByTeamAccountCountry(teamAccountCountryCode);
        // https://caniuse.com/?search=Intl very small percentage of browser don't have Intl
        // so wrapping in try/catch
        var numberFormatter = Intl.NumberFormat(locale, {
            currency: currency,
            style: 'currency',
        });
        var parts = numberFormatter.formatToParts(DEFAULT_CURRENCY_AMOUNT_FOR_SYMBOL);
        var currencyPart = parts.find(function (_a) {
            var type = _a.type;
            return type === 'currency';
        });
        if (!currencyPart) {
            return getDefaultCurrencySymbol(getCurrencyByTeamAccountCountry(teamAccountCountryCode));
        }
        return currencyPart.value;
    }
    catch (_a) {
        return getDefaultCurrencySymbol(getCurrencyByTeamAccountCountry(teamAccountCountryCode));
    }
};
